// Mock data for Inventia Landing Page
export const mockData = {
  hero: {
    headline: "Securing Tomorrow's Digital Infrastructure",
    subheadline: "Enterprise-grade cybersecurity and IT solutions engineered for precision, scalability, and resilience.",
    cta: {
      primary: "Get Started",
      secondary: "View Solutions"
    }
  },
  
  services: [
    {
      id: 1,
      title: "Barcode & RFID Solutions",
      description: "Complete barcode and RFID solutions including barcode scanners, barcode printers, RFID readers, asset tracking systems, warehouse barcode systems, and inventory tracking solutions.",
      icon: "scan",
      features: ["Enterprise barcode printing & scanning systems", "RFID-enabled warehouse tracking systems", "Real-time inventory visibility"]
    },
    {
      id: 2,
      title: "Cyber Security Solutions",
      description: "Comprehensive cybersecurity services including network security solutions, endpoint security, firewall solutions, SIEM solutions, vulnerability assessment, and penetration testing.",
      icon: "shield",
      features: ["Zero Trust security architecture", "Network & endpoint protection", "Real-time threat detection & response"]
    },
    {
      id: 3,
      title: "High-Performance Networking",
      description: "Robust networking infrastructure solutions including structured cabling services, LAN WAN network solutions, fiber optic cabling, wireless networks, CCTV surveillance systems, and access control systems.",
      icon: "network",
      features: ["Enterprise LAN & WAN architecture", "SD-WAN implementation", "Secure network segmentation"]
    },
    {
      id: 4,
      title: "Infrastructure & Cloud Solutions",
      description: "Secure cloud and data center solutions including private cloud, hybrid cloud, data center design services, server virtualization, cloud migration services, and backup and disaster recovery.",
      icon: "server",
      features: ["Server & data center architecture", "Cloud migration & hybrid IT", "DevOps automation"]
    }
  ],
  
  projects: [
    {
      id: 1,
      title: "Financial Sector Security Overhaul",
      category: "Cybersecurity",
      description: "Implemented zero-trust architecture for a leading financial institution, reducing security incidents by 87% while maintaining seamless user experience.",
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=1200",
      metrics: { security: "87%", uptime: "99.9%" }
    },
    {
      id: 2,
      title: "Smart Warehouse RFID Integration",
      category: "RFID Solutions",
      description: "Deployed intelligent tracking system across 5 distribution centers, automating inventory accuracy to 99.8% and reducing manual audits by 70%.",
      image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=1200",
      metrics: { accuracy: "99.8%", efficiency: "70%" }
    },
    {
      id: 3,
      title: "Enterprise Network Transformation",
      category: "Networking",
      description: "Architected SD-WAN infrastructure for global enterprise, connecting 45 offices across 12 countries with 40% cost reduction.",
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=1200",
      metrics: { cost: "-40%", performance: "+120%" }
    },
    {
      id: 4,
      title: "Cloud-Native Infrastructure Migration",
      category: "IT Infrastructure",
      description: "Orchestrated seamless migration of legacy systems to containerized cloud architecture, achieving 5x deployment velocity.",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1200",
      metrics: { velocity: "5x", savings: "60%" }
    }
  ],
  
  testimonials: [
    {
      id: 1,
      quote: "Inventia's security infrastructure transformed our operations. Their zero-trust implementation is flawless.",
      author: "Sarah Chen",
      position: "CTO, GlobalTech Financial",
      company: "GlobalTech"
    },
    {
      id: 2,
      quote: "The RFID solution delivered beyond expectations. Inventory accuracy went from 92% to 99.8% in three months.",
      author: "Michael Rodriguez",
      position: "VP Operations, LogisticsPro",
      company: "LogisticsPro"
    },
    {
      id: 3,
      quote: "Best network architecture partner we've worked with. Their SD-WAN deployment was seamless across all regions.",
      author: "Emily Watson",
      position: "Infrastructure Director, MegaCorp",
      company: "MegaCorp"
    },
    {
      id: 4,
      quote: "Inventia doesn't just provide solutions—they engineer complete ecosystems. Our cloud migration was a masterclass.",
      author: "David Kim",
      position: "Chief Architect, InnovateTech",
      company: "InnovateTech"
    }
  ],
  
  footer: {
    tagline: "Engineering Tomorrow's Secure Infrastructure",
    services: ["Cybersecurity", "RFID & Barcode", "Networking", "IT Infrastructure"],
    company: ["About Us", "Careers", "Partners", "Case Studies"],
    resources: ["Blog", "Whitepapers", "Documentation", "Support"],
    legal: ["Privacy Policy", "Terms of Service", "Security"],
    social: {
      linkedin: "https://www.linkedin.com/in/neeraj-chobisa?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      twitter: "#",
      github: "#"
    },
    contact: {
      email: "contact@inventia.tech",
      phone: "+1 (555) 123-4567",
      address: "123 Tech Boulevard, Innovation District"
    }
  }
};
